import React, { useState } from "react";
import MatchTab from "./Tabs/NextMatch.js";
import DonationsTab from "./Tabs/Donations.js";
import GalleryTab from "./Tabs/Gallery.js";
import StatsTab from "./Tabs/StatsTab.js";
import TodoTab from "./Tabs/ToDoTab.js";
import RaffleTickets from "./Tabs/RaffleTickets.js";
import SupporterGalleryTab from "./Tabs/Supporter Images.js";
import AdminUsersTab from "./Tabs/AdminUsers.js";
import RedirectsTab from "./Tabs/Redirects.js";
import AuctionsTab from "./Tabs/Auctions.js";
import RafflePrizesTab from "./Tabs/RafflePrizes.js";
import "./Admin.css";
import { useConfig } from "../context/ConfigContext";

export default function AdminDashboard({ user }) {
  const [active, setActive] = useState("match");
  const { config } = useConfig();

  if (!config) {
    return (
      <div className="admin">
        <p>Loading admin configuration…</p>
      </div>
    );
  }
  const handleLogout = async () => {
    try {
      await fetch(config.REACT_APP_LOGOUTURL, {
        method: "POST",
        credentials: "include",
      });

      // Reload or redirect after logout
      window.location.href = "/login";
    } catch (err) {
      console.error("Logout failed", err);
    }
  };

  const tabs = [
    { id: "match", label: "Match Info" },
    { id: "donations", label: "Donations" },
    { id: "gallery", label: "Gallery" },
    { id: "stats", label: "Stats" },
    { id: "todo", label: "To-Do" },
    { id: "raffletickets", label: "Raffle Tickets" },
    { id: "supporter-images", label: "Supporter Images" },
    { id: "redirects", label: "Redirects" },
    { id: "admin-users", label: "Admin Users" },
    { id: "auctions", label: "Auctions" },
    { id: "raffle-prizes", label: "Raffle Prizes" },
  ];

  return (
    <div className="admin">
      <header className="admin-header">
        <div className="admin-header-row">
          <div>
            <h1>Admin Dashboard</h1>
            <p className="muted">
              Manage content and settings for the memorial match.
            </p>
          </div>

          <button
            type="button"
            className="btn danger"
            onClick={handleLogout}
          >
            Log out
          </button>
        </div>
      </header>

      <nav className="admin-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={active === tab.id ? "active" : ""}
            onClick={() => setActive(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </nav>

      <div className="admin-content">
        {active === "match" && <MatchTab />}
        {active === "donations" && <DonationsTab />}
        {active === "gallery" && <GalleryTab />}
        {active === "stats" && <StatsTab />}
        {active === "todo" && <TodoTab />}
        {active === "raffletickets" && <RaffleTickets />}
        {active === "supporter-images" && <SupporterGalleryTab />}
        {active === "redirects" && <RedirectsTab />}
        {active === "auctions" && <AuctionsTab />}
        {active === "admin-users" && <AdminUsersTab apiBase={config.apiUrl} user={user} />}
        {active === "raffle-prizes" && <RafflePrizesTab />}
      </div>
    </div>
  );
}
